import { Col, Row, Space, Typography, Button } from "antd";
import { FC, useContext, useEffect, useState } from "react";

import { useTheme } from "../../../Styles/ThemeHook";
import { UserStateContext } from "shared-components/Contexts/User/context";
import dynamic from "next/dynamic";
import { useUser } from "shared-components/Components/User/User.hook";
import Mandatory from "shared-components/Components/User/Mandatory/web";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
const Modal = dynamic(() => import("shared-components/Components/Modal/web").then(mod => mod.Modal), { ssr: false });

type onAskFunction = (field: string) => Promise<Object>;

interface TechnicalItemProps {
	field: string;
	text: string;
	value: string;
	onAsk: onAskFunction;
	showSimilars: Function;
	isDisabledProperty?: boolean;
}

export const TechnicalItem: FC<TechnicalItemProps> = ({
	field,
	text,
	value,
	onAsk,
	showSimilars = null,
	isDisabledProperty = false,
}) => {
	const [asked, setAsked] = useState(false);
	const { theme } = useTheme();
	const user = useContext(UserStateContext);
	const { isLoggedIn, user: { refetch } } = useUser()
	const [userHasAllData, setUserHasAllData] = useState(false);
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [fieldToAsk, setFieldToAsk] = useState("");
	const { country_code } = useContext(ConfigStateContext);

	const askFastAction = async field => {
		let res = await onAsk(field);
		if (res) {
			setAsked(true);
			if (showSimilars) {
				showSimilars();
			}
		}
	};

	useEffect(() => {
		if (country_code !== "CO") {
			setUserHasAllData(true);
		}
		if (country_code === "CO" && user.me) {
			const hasAllData = !!user.me.phone && !!user.me.name;
			setUserHasAllData(hasAllData);
		}
	}, [user.me]);

	const SpanAskFast = ({ field }) => {
		if (asked) {
			return <Typography.Text disabled>{"¡Preguntado!"}</Typography.Text>;
		} else {
			return (
				<Button
					type="text"
					disabled={isDisabledProperty}
					onClick={() => {
						if (!isDisabledProperty) {
							if (userHasAllData || !isLoggedIn) {
								askFastAction(field);
							} else {
								setFieldToAsk(field);
								setIsModalVisible(true);
							}
						} else { null }
					}}
					className="btnQuestion"
				>
					{"¡Pregúntale!"}
				</Button>
			);
		}
	};

	return (
		<Row key={field} gutter={theme.spacing.mdSpacing} justify="space-between">
			<Col>
				<Space size={theme.spacing.xsSpacing}>
					<Typography.Text type={"secondary"} className="small">
						•{" "}
					</Typography.Text>
					<Typography.Text>{text}</Typography.Text>
				</Space>
			</Col>
			<Col flex={1} className="dots" />
			<Col>
				{value && value != null ? (
					<Typography.Paragraph
						strong
						title={value}
						style={{ margin: 0 }}
						ellipsis={{ rows: 2 }}>
						{value}
					</Typography.Paragraph>
				) : (
					<SpanAskFast field={field} />
				)}
			</Col>
			<Modal
				show={isModalVisible}
				onClose={() => setIsModalVisible(false)}
				height="500px"
			>
				<div className="auth-modal-wrapper">
					<div className="auth-modal">
						<Mandatory
							onOk={() => {
								askFastAction(fieldToAsk);
								setIsModalVisible(false);
								refetch();
								setUserHasAllData(true);
							}}
							user={user}
						/>
					</div>
				</div>
			</Modal>
		</Row>
	);
};
